import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    st0: { fill: '#0a6eb4' },
    st1: { fontWeight: 'bold' },
    st2: { fontSize: '14.2988px' },
    st3: { fill: 'none', stroke: '#F47721', strokeWidth: '26.432' },
    st4: { fill: 'none', stroke: '#F47721', strokeWidth: '26.432' },
    st5: { fill: 'none', stroke: '#833444', strokeWidth: '26.432' },
    st6: { fill: 'none', stroke: '#F1BA8A', strokeWidth: '26.432' },
    st7: { fill: 'none', stroke: '#0076BC', strokeWidth: '22.445' },
    st8: { fill: 'none', stroke: '#00ADD8', strokeWidth: '22.445', strokeLinejoin: 'round' },
    st9: { fill: '#FFFFFF' },
    st10: { fill: '#034EA2' },
    st11: { fontSize: '11.8572px' },
    st12: { fontSize: '26.1708px' },
    st13: { letterSpacing: '-3' },
    st14: { fontSize: '14.2993px' },
    st15: { fontSize: '14.2994px' },
    st16: { fontSize: '14.2995px' },
    st17: { fontSize: '14.2982px' },
    st18: { fontSize: '14.2987px' },
    st19: { fill: 'none', stroke: '#00ADD8', strokeWidth: '1.634' },
    st20: { fill: 'none', stroke: '#00ADD8', strokeWidth: '1.634' },
    st21: {
      fill: 'none',
      stroke: '#0a6eb4',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.048',
    },
    st22: { fill: 'none', stroke: '#0a6eb4', strokeLinecap: 'round', strokeLinejoin: 'round' },
    st23: {
      fill: 'none',
      stroke: '#0a6eb4',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.166',
    },
    st24: {
      fill: 'none',
      stroke: '#0a6eb4',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,2.529',
    },
    st25: {
      fill: 'none',
      stroke: '#0a6eb4',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.047',
    },
    st26: {
      fill: 'none',
      stroke: '#0a6eb4',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.041',
    },
    st27: { fill: '#00ADD8' },
    st28: { fill: '#F47721' },
    st29: { fill: '#0076BC' },
    st30: { fill: '#F1BA8A' },
    st31: { fill: '#833444' },
  }),
);

const FundingFigures = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 228.89 269.28" ref={ref}>
      <g>
        <text
          transform="matrix(1 0 0 1 159.9413 256.513)"
          className={clsx(classes.st0, classes.st1, classes.st2)}
        >
          € 541 M
        </text>
        <path className={classes.st3} d="M201.67,128.58c-1.1,4.62-2.52,9.12-4.21,13.48" />
        <path className={classes.st3} d="M203.32,120.11c-0.21,1.39-0.46,2.78-0.72,4.16" />
        <path className={classes.st3} d="M202.6,124.27c-0.28,1.45-0.59,2.88-0.94,4.31" />
        <path className={classes.st3} d="M203.97,115.13c-0.05,0.46-0.1,0.92-0.15,1.38" />
        <path
          className={classes.st3}
          d="M204.55,104.02c0,3.46-0.17,6.89-0.49,10.26 M204.05,114.28c-0.03,0.28-0.06,0.57-0.09,0.85"
        />
        <path className={classes.st3} d="M203.81,116.51c-0.14,1.21-0.31,2.41-0.49,3.6" />
        <path className={classes.st4} d="M197.46,142.06c-12.69,32.7-41.27,57.47-76.26,64.84" />
        <path className={classes.st5} d="M106.17,208.95c-2.24,0.14-4.49,0.21-6.77,0.21" />
        <path className={classes.st6} d="M121.2,206.9c-4.89,1.03-9.91,1.72-15.03,2.05" />
        <path
          className={classes.st7}
          d="M99.41,185.01c-45.04,0-81.55-36.51-81.55-81.55s36.51-81.55,81.55-81.55s81.55,36.51,81.55,81.55"
        />
        <path className={classes.st8} d="M180.96,103.46c0,45.04-36.51,81.55-81.55,81.55" />
        <path
          className={classes.st9}
          d="M99.82,175.33c40.15,0,72.69-32.54,72.69-72.69s-32.54-72.69-72.69-72.69s-72.69,32.54-72.69,72.69
		S59.67,175.33,99.82,175.33"
        />
        <path
          className={classes.st10}
          d="M100.04,162.83c33.24,0,60.19-26.95,60.19-60.19s-26.95-60.19-60.19-60.19S39.85,69.4,39.85,102.64
		S66.8,162.83,100.04,162.83"
        />
      </g>
      <text
        transform="matrix(1 0 0 1 72.2836 111.636)"
        className={clsx(classes.st9, classes.st1, classes.st11)}
      >
        TOTAL EU{' '}
      </text>
      <text
        transform="matrix(1 0 0 1 59.5844 124.7034)"
        className={clsx(classes.st9, classes.st1, classes.st11)}
      >
        FUNDING FOR{' '}
      </text>
      <text
        transform="matrix(1 0 0 1 64.5644 137.7698)"
        className={clsx(classes.st9, classes.st1, classes.st11)}
      >
        WFP IN 2019
      </text>

      {inView && (
        <CountUp delay={0} decimals={2} end={2.42} prefix="€">
          {({ countUpRef }) => (
            <text
              ref={countUpRef}
              transform="matrix(1 0 0 1 53.3657 89.9212)"
              className={clsx(classes.st9, classes.st1, classes.st12)}
            ></text>
          )}
        </CountUp>
      )}

      <text
        transform="matrix(1 0 0 1 127.3557 89.9212)"
        className={clsx(classes.st9, classes.st1, classes.st12, classes.st13)}
      >
        {' '}
      </text>
      <text
        transform="matrix(1 0 0 1 129.4457 89.9212)"
        className={clsx(classes.st9, classes.st1, classes.st12)}
      >
        B
      </text>
      <text
        transform="matrix(0.8712 -0.491 0.491 0.8712 140.3965 179.3146)"
        className={clsx(classes.st9, classes.st1, classes.st14)}
      >
        €
      </text>
      <text
        transform="matrix(0.8327 -0.5538 0.5538 0.8327 147.6025 175.2067)"
        className={clsx(classes.st9, classes.st1, classes.st15)}
      >
        {' '}
      </text>
      <text
        transform="matrix(0.79 -0.6131 0.6131 0.79 150.771 173.2502)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        6
      </text>
      <text
        transform="matrix(0.7271 -0.6865 0.6865 0.7271 157.2563 168.2818)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        1
      </text>
      <text
        transform="matrix(0.6581 -0.753 0.753 0.6581 163.2164 162.694)"
        className={clsx(classes.st9, classes.st1, classes.st16)}
      >
        3
      </text>
      <text
        transform="matrix(0.6025 -0.7981 0.7981 0.6025 168.536 156.5048)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        {' '}
      </text>
      <text
        transform="matrix(0.5439 -0.8391 0.8391 0.5439 170.0708 154.7907)"
        className={clsx(classes.st9, classes.st1, classes.st17)}
      >
        M
      </text>
      <text
        transform="matrix(0.6457 -0.7636 0.7636 0.6457 38.3802 56.7057)"
        className={clsx(classes.st9, classes.st1, classes.st18)}
      >
        €
      </text>
      <text
        transform="matrix(0.7155 -0.6986 0.6986 0.7155 43.8173 50.441)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        {' '}
      </text>
      <text
        transform="matrix(0.7636 -0.6457 0.6457 0.7636 46.3769 47.735)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        1
      </text>
      <text
        transform="matrix(0.8079 -0.5893 0.5893 0.8079 52.6186 42.4729)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        .
      </text>
      <text
        transform="matrix(0.8483 -0.5295 0.5295 0.8483 55.7219 40.0455)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        8
      </text>
      <text
        transform="matrix(0.8955 -0.445 0.445 0.8955 62.6214 35.6686)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        1
      </text>
      <text
        transform="matrix(0.9162 -0.4008 0.4008 0.9162 69.9627 32.1051)"
        className={clsx(classes.st9, classes.st1, classes.st14)}
      >
        {' '}
      </text>
      <text
        transform="matrix(0.9432 -0.3322 0.3322 0.9432 71.7566 31.2036)"
        className={clsx(classes.st9, classes.st1, classes.st2)}
      >
        B
      </text>
      <g>
        <line className={classes.st19} x1="219.11" y1="104.33" x2="172.51" y2="104.33" />
        <path
          className={classes.st19}
          d="M218.29,104.7c0,3.88-0.19,7.72-0.55,11.5 M217.73,116.2c-0.03,0.32-0.06,0.63-0.1,0.95"
        />
        <path className={classes.st19} d="M215.06,132.21c-1.24,5.18-2.82,10.22-4.72,15.1" />
        <path className={classes.st19} d="M216.92,122.73c-0.24,1.56-0.51,3.11-0.81,4.66" />
        <path className={classes.st19} d="M217.47,118.7c-0.16,1.35-0.34,2.7-0.55,4.04" />
        <path className={classes.st19} d="M217.64,117.15c-0.05,0.52-0.11,1.03-0.17,1.55" />
        <path className={classes.st19} d="M216.11,127.39c-0.32,1.62-0.67,3.23-1.05,4.83" />
        <path className={classes.st20} d="M210.34,147.32c-17.08,44-60.9,75.06-110.94,75.06" />
      </g>
      <line className={classes.st19} x1="99.41" y1="175.33" x2="99.41" y2="222.96" />
      <line className={classes.st21} x1="186.85" y1="236.51" x2="186.85" y2="164.9" />
      <path
        className={classes.st22}
        d="M186.85,163.37L186.85,163.37 M186.85,239.56L186.85,239.56"
      />
      <line className={classes.st23} x1="119.04" y1="236.4" x2="119.04" y2="215.81" />
      <path
        className={classes.st22}
        d="M119.04,214.23L119.04,214.23 M119.04,239.56L119.04,239.56"
      />
      <line className={classes.st24} x1="54.47" y1="237.53" x2="54.47" y2="233.74" />
      <line className={classes.st25} x1="57.52" y1="232.48" x2="101.7" y2="232.48" />
      <line className={classes.st26} x1="103.23" y1="229.43" x2="103.23" y2="215.75" />
      <path
        className={classes.st22}
        d="M103.23,214.23L103.23,214.23 M103.23,232.48L103.23,232.48 M54.47,232.48L54.47,232.48 M54.47,240.06
	L54.47,240.06"
      />
      <g>
        <text
          transform="matrix(1 0 0 1 96.6269 256.513)"
          className={clsx(classes.st0, classes.st1, classes.st2)}
        >
          € 48 M
        </text>
        <text
          transform="matrix(1 0 0 1 32.3969 256.513)"
          className={clsx(classes.st0, classes.st1, classes.st2)}
        >
          € 24 M
        </text>
      </g>
    </svg>
  );
};

export default FundingFigures;
